import { useMutation, useQueryClient } from 'react-query';
import { deleteUserFace, setUserFace } from '../../services/apis/UserFaceApi';

const useUserFaceMutation = () => {
	const queryClient = useQueryClient();

	return useMutation(
		async ({ data, file, type = 'add' }) => {
			if (type === 'add') {
				const formData = new FormData();
				formData.append('file', file);
				await setUserFace(data, formData);
			} else {
				await deleteUserFace(data);
			}
		},
		{
			onSuccess: (data) => {
				queryClient.refetchQueries(['user_face']);
				return true;
			},
			onError: (error) => {
				console.error(error);
				return false;
			},
		},
	);
};

export default useUserFaceMutation;
